export const PATHWRIGHT_SCHOOL_ID = 7888
